export default {"src":"/_next/static/media/arrow-external.812128a3.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};